import { render, staticRenderFns } from "./artist-profile-detail.vue?vue&type=template&id=40ea669e&scoped=true"
import script from "./artist-profile-detail.vue?vue&type=script&lang=js"
export * from "./artist-profile-detail.vue?vue&type=script&lang=js"
import style0 from "./artist-profile-detail.vue?vue&type=style&index=0&id=40ea669e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea669e",
  null
  
)

export default component.exports